import micromodal from 'micromodal';

function initTabsModal() {
    const tabsWLists = document.querySelectorAll('.section-tabs');

    tabsWLists.forEach(tabSection => {
        let modalBtn = tabSection.querySelector('.tabs-modal-btn');
        let modalContainer = document.getElementById(modalBtn.dataset.modalToOpen);
        let modalContentObject = {};
        const btnNext = tabSection.querySelector('.modal-content-next');
        const btnPrev = tabSection.querySelector('.modal-content-prev');
        let activeModalPlayer = null;

        initModalContentIds(modalContainer);
        initNavBtns(modalContainer);

        /* Set data attributes with content IDs */
        function initModalContentIds(modal) {
            let playerContainer = modal.closest('.player-container-desktop');

            modal.dataset.contentJson = playerContainer.dataset.contentJson;
            modal.dataset.activeContentKey = playerContainer.dataset.activeContentKey;

            modalContentObject = JSON.parse(modal.dataset.contentJson);
        }

        function initNavBtns(modal) {
            btnNext.addEventListener('click', () => nextContent(modal, 1));
            btnPrev.addEventListener('click', () => nextContent(modal, -1));
        }

        function nextContent(modal, direction) {
            let activeContentKey = modal.dataset.activeContentKey;
            let nextContentKey = parseInt(activeContentKey) + direction;

            if (direction === 1) {
                nextContentKey > Object.keys(modalContentObject).length - 1 ? nextContentKey = 0 : nextContentKey;
            } else {
                nextContentKey < 0 ? nextContentKey = Object.keys(modalContentObject).length - 1 : nextContentKey;
            }

            modal.dataset.activeContentKey = nextContentKey;

            if (activeModalPlayer) {
                activeModalPlayer.pauseVideo();
            }

            initModalContent(modal);
        }

        /* Set content based on data attributes */
        function initModalContent(modal) {
            let activeContentKey = modal.dataset.activeContentKey;
            let content = modalContentObject[activeContentKey];

            if (content.content_type === 'image') {
                showImageContainer(modal);
            } else {
                showVideoContainer(modal);
            }
        }

        function showImageContainer(modal) {
            let imageContainer = modal.querySelector('.modal-image-container');
            let videoContainer = modal.querySelector('.modal-video-container');

            /* Set modal image url */
            imageContainer.querySelector('img').src = modalContentObject[modal.dataset.activeContentKey].url;

            imageContainer.classList.contains('hidden') && imageContainer.classList.remove('hidden');
            !videoContainer.classList.contains('hidden') && videoContainer.classList.add('hidden');

            handlePager(modal);
        }

        function showVideoContainer(modal) {
            let imageContainer = modal.querySelector('.modal-image-container');
            let videoContainer = modal.querySelector('.modal-video-container');

            activeModalPlayer.cueVideoById(modalContentObject[modal.dataset.activeContentKey].youtube_id);

            !imageContainer.classList.contains('hidden') && imageContainer.classList.add('hidden');
            videoContainer.classList.contains('hidden') && videoContainer.classList.remove('hidden');

            handlePager(modal);
        }

        function handlePager(modal) {
            let pager = modal.querySelector('.modal-pager');
            pager.querySelector('.modal-pager-current').innerHTML = (parseInt(modal.dataset.activeContentKey) + 1).toString().padStart(2, '0');
            pager.querySelector('.modal-pager-total').innerHTML = Object.keys(modalContentObject).length.toString().padStart(2, '0');
        }

        modalBtn.addEventListener('click', () => {
            micromodal.show(modalBtn.dataset.modalToOpen, {
                onShow: modal => {
                    initModalContentIds(modal);
                    initModalContent(modal);
                    createVideoPlayer(modal);
                    initVideoPlayer(modal);
                },
                onClose: modal => {
                    modal.dataset.activeContentKey = 0;

                    if (activeModalPlayer) {
                        activeModalPlayer.destroy();
                        activeModalPlayer = null;
                    }
                },
                openTrigger: 'data-tabs-modal-open',
                closeTrigger: 'data-tabs-modal-close',
                openClass: 'is-open',
                disableScroll: true,
                disableFocus: true,
                awaitOpenAnimation: false,
                awaitCloseAnimation: false,
                debugMode: false
            })

            /* Initialize video player */
            function initVideoPlayer(modal) {
                if (document.getElementById('iframe_api') === null) {
                    var tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    tag.id = "iframe_api";
                    var firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }

                window.onYouTubeIframeAPIReady = function () {
                    createVideoPlayer(modal);
                }
            }

            function createVideoPlayer(modal) {
                let videoPlayerDiv = modal.querySelector('.modal-video-player');
                const firstVideoId = getFirstVideoId();

                if (firstVideoId) {
                    const currentVideoId = modalContentObject[modal.dataset.activeContentKey].content_type === 'video' ? modalContentObject[modal.dataset.activeContentKey].youtube_id : getFirstVideoId();
                    videoPlayerDiv.src = modalContentObject[modal.dataset.activeContentKey].url;

                    let modalPlayer = new YT.Player(videoPlayerDiv.id, {
                        height: '100%',
                        width: '100%',
                        videoId: currentVideoId,
                        playerVars: {
                            autoplay: 0,
                            enablejsapi: 1,
                            rel: 0,
                            origin: 'http://itera-hrm.local/*',
                        },
                        events: {
                            'onReady': function (event) {
                                activeModalPlayer = event.target;
                            },
                            'onStateChange': function (event) {
                                if (event.data === YT.PlayerState.CUED) {
                                    activeModalPlayer = event.target;
                                }
                            }
                        }
                    });
                } else {
                    /* console.log('no video'); */
                }
            }

            function getFirstVideoId() {
                let idToReturn = null;

                for (let i = 0; i < modalContentObject.length; i++) {
                    const content = modalContentObject[i];
                    if (content.content_type === 'video') {
                        idToReturn = content.youtube_id;
                        break;
                    }
                }

                return idToReturn;
            }
        });

    });
}

export { initTabsModal };